export enum WidgetType {
    Calculator = "calculator",
    Locations = "locations"
}